/* Kōbu Content Creator Program — minimal enhancement JS.
   Scoped to .kobu-contentcreator. Provides:
   - smooth-scroll for in-page anchor links
   - reveal-on-scroll for [data-ki-reveal]
   - FAQ accordion: close siblings when opening one
   - form: honeypot check + basic client-side required validation
*/
(function () {
  var roots = document.querySelectorAll('.kobu-contentcreator');
  if (!roots.length) return;

  roots.forEach(function (root) {
    // Smooth scroll for in-page anchors
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var firstField = target.querySelector('input, select, textarea');
      if (firstField) setTimeout(function () { firstField.focus({ preventScroll: true }); }, 500);
    });

    // Reveal on scroll
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      root.querySelectorAll('[data-ki-reveal]').forEach(function (el) { io.observe(el); });
    } else {
      root.querySelectorAll('[data-ki-reveal]').forEach(function (el) { el.classList.add('is-in'); });
    }

    // FAQ single-open
    root.querySelectorAll('.ki-faq').forEach(function (faq) {
      faq.addEventListener('toggle', function (e) {
        var d = e.target;
        if (d.tagName !== 'DETAILS' || !d.open) return;
        faq.querySelectorAll('details[open]').forEach(function (other) {
          if (other !== d) other.open = false;
        });
      }, true);
    });

    // Form: honeypot + polite client validation
    var form = root.querySelector('form.ki-form-container');
    if (form) {
      form.addEventListener('submit', function (e) {
        var trap = form.querySelector('.ki-honeypot input');
        if (trap && trap.value) { e.preventDefault(); return; }
        var missing = null;
        form.querySelectorAll('[required]').forEach(function (el) {
          if (!missing && !String(el.value || '').trim()) missing = el;
        });
        if (missing) {
          e.preventDefault();
          missing.focus();
          missing.reportValidity && missing.reportValidity();
          return;
        }

        var submitButton = form.querySelector('.ki-submit-button');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.classList.add('is-loading');
          submitButton.setAttribute('aria-busy', 'true');
        }
      });
    }
  });
})();
